import { momentWithLocale as moment } from '../locale/i18n.js';
import sanitize from '../util/sanitize.js';

export const FLIGHT_SEARCH_STORAGE = 'flight_search';

const defaultState = {
    isOneway: false,
    isRoundtrip: true,
    isMulticity: false,
    tripType: 'roundtrip',
    departureDate: null,
    returnDate: null,
    origin: '',
    originText: '',
    originCity: '',
    originCountry: '',
    destination: '',
    destinationText: '',
    destinationCity: '',
    destinationCountry: '',
    origin2: '',
    originText2: '',
    originCity2: '',
    originCountry2: '',
    destination2: '',
    destinationText2: '',
    destinationCity2: '',
    destinationCountry2: '',
    adults: 1,
    children: [],
    cabinType: 'economy',
    showPassengerWarning: false,
};

export const createChildren = num => Array.from({ length: num }, () => 8);

export const checkDates = data => {
    if (!data) {
        return {};
    }
    if (data.departureDate && !moment(data.departureDate).isBetween(moment(), moment().add(6, 'months'), 'day', '[]')) {
        delete data.departureDate;
    }
    if (data.returnDate && !moment(data.returnDate).isBetween(moment(), moment().add(6, 'months'), 'day', '[]')) {
        delete data.returnDate;
    }
    return data;
};

export const mapLastSearchData = data => {
    if (!data) {
        return {};
    }

    const fieldMap = {
        isOneway: () => (data.tripType ? data.tripType === 'oneway' : undefined),
        isRoundtrip: () => (data.tripType ? data.tripType === 'roundtrip' : undefined),
        isOpenjaw: () => (data.tripType ? data.tripType === 'openjaw' : undefined),
        tripType: 'tripType',
        departureDate: 'requestedDepartureDate',
        returnDate: 'requestedReturnDate',
        origin: 'requestedOrigin',
        originText: 'requestedOriginName',
        originCity: 'requestedOriginCity',
        originCountry: 'requestedOriginCountry',
        destination: 'requestedDestination',
        destinationText: 'requestedDestinationName',
        destinationCity: 'requestedDestinationCity',
        destinationCountry: 'requestedDestinationCountry',
        origin2: 'requestedOrigin2',
        originText2: 'requestedOriginName2',
        originCity2: 'requestedOriginCity2',
        originCountry2: 'requestedOriginCountry2',
        destination2: 'requestedDestination2',
        destinationText2: 'requestedDestinationName2',
        destinationCity2: 'requestedDestinationCity2',
        destinationCountry2: 'requestedDestinationCountry2',
        cabinType: 'cabinType',
        children: () =>
            (Array.isArray(data.children) && data.children) ||
            (Array.isArray(data.childAges) && data.childAges) ||
            (Number.parseInt(data.numberOfChildren, 10) && createChildren(data.numberOfChildren)) ||
            undefined,
        adults: () => Number.parseInt(data.numberOfAdults, 10) || undefined,
    };

    return checkDates(
        Object.keys(fieldMap).reduce((result, key) => {
            const source = fieldMap[key];
            const value = typeof source === 'function' ? source() : data[source] || undefined;

            if (value !== undefined) {
                result[key] = value;
            }
            return result;
        }, {})
    );
};

export const storeLastSearch = data =>
    window.localStorage.setItem(FLIGHT_SEARCH_STORAGE, JSON.stringify(sanitize(data, Object.keys(defaultState))));

const lastSearchStorage = typeof window !== 'undefined' && JSON.parse(window.localStorage.getItem(FLIGHT_SEARCH_STORAGE));
const lastSearchUserData = (typeof window !== 'undefined' && window.FINN && window.FINN.travel && window.FINN.travel.lastSearch) || {};

export function getDefaultState(defaultData, localStorageData, userData) {
    return Object.assign(defaultData, checkDates(localStorageData), mapLastSearchData(userData));
}

export default getDefaultState(defaultState, lastSearchStorage, lastSearchUserData);
